var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"strip"}),_c('VueDocPreview',{attrs:{"value":_vm.selected_file.docValue,"type":_vm.selected_file.docType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }